import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ConditionOfferState {
  term?: number;
  insurance?: boolean;
  isShowInsuranceModal: boolean;
  isShowGracePeriodInfoModal: boolean;
  isShowActiveOfferConflictModal: boolean;
  offerImprovements: Record<string, boolean>;
}

const initialState: ConditionOfferState = {
  term: undefined,
  insurance: undefined,
  isShowInsuranceModal: false,
  isShowGracePeriodInfoModal: false,
  isShowActiveOfferConflictModal: false,
  offerImprovements: {},
};

export const conditionsSelectionSlice = createSlice({
  name: 'conditionsSelection',
  initialState,
  reducers: {
    setTerm(state, action: PayloadAction<number>) {
      state.term = action.payload;
    },
    setOfferImprovements(state, action: PayloadAction<ConditionOfferState['offerImprovements']>) {
      state.offerImprovements = {
        ...state.offerImprovements,
        ...action.payload,
      };
    },
    toggleInsurance(state) {
      state.insurance = !state.insurance;
    },
    setInsurance(state, action: PayloadAction<boolean>) {
      state.insurance = action.payload;
    },
    toggleIsShowInsuranceModal(state) {
      state.isShowInsuranceModal = !state.isShowInsuranceModal;
    },
    toggleIsShowGracePeriodInfoModal(state) {
      state.isShowGracePeriodInfoModal = !state.isShowGracePeriodInfoModal;
    },
    setIsShowActiveOfferConflictModal(state, action: PayloadAction<boolean>) {
      state.isShowActiveOfferConflictModal = action.payload;
    },
  },
});

export const {
  setTerm,
  toggleInsurance,
  toggleIsShowInsuranceModal,
  setOfferImprovements,
  setInsurance,
  toggleIsShowGracePeriodInfoModal,
  setIsShowActiveOfferConflictModal,
} = conditionsSelectionSlice.actions;
